<template>
  <div class="public-layout">
    <AppHeader />
    <main class="main-content">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppHeader from '@/components/common/AppHeader.vue';
// import AdminHeader from '@/components/admin/AdminHeader.vue'; // À créer si besoin
import AppFooter from '@/components/common/AppFooter.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    AppHeader,
    AppFooter
  }
});
</script>

<style lang="scss" scoped>
.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style>